<template>
    <div class="p-3 row justify-content-center">
        <el-card class="col-12 print-sheet" :header="event.id ? event.name:'Procurando Evento'">
            <el-skeleton :loading="loading" animated :rows="12" class="no-print">
                <template #default>
                    <el-form :disabled="saving" v-if="event" :model="event" label-position="top" :rules="rules" ref="formRef" class="no-print">
                        <el-row :gutter="30">
                            <el-col :sm="24" :md="12" :lg="10">
                                <el-form-item label="Nome do evento" prop="name">
                                    <el-input name="name" v-model="event.name" />
                                </el-form-item>
                                <el-form-item label="Tipo do evento" prop="type">
                                    <el-input name="type" v-model="event.type" />
                                </el-form-item>
                                <el-form-item label="Data e hora" prop="event_time">
                                    <ElDatePicker type="datetime" format="DD/MM/YYYY HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss" name="event_time" :clearable="false" v-model="event.event_time" />
                                </el-form-item>
                                <el-form-item label="Descricao do evento" prop="description">
                                    <el-input type="textarea" name="description" v-model="event.description" />
                                </el-form-item>
                                <ElRow>
                                    <ElCol :sm="12" :md="12">
                                        <ElFormItem label="Preço normal" prop="price">
                                            <ElInputNumber name="price" v-model="event.price" :step="0.001" :min="0" />
                                        </ElFormItem>
                                    </ElCol>
                                    <ElCol :sm="12" :md="12">
                                        <ElFormItem label="Preço VIP" prop="vip_price">
                                            <ElInputNumber name="vip_price" v-model="event.vip_price" :step="0.001" :min="0" />
                                        </ElFormItem>
                                    </ElCol>
                                </ElRow>
                                <ElRow>
                                    <ElCol :sm="12" :md="12">
                                        <ElFormItem label="Nr de lugares normais" prop="places">
                                            <ElInputNumber name="places" v-model="event.places" :step="1" :min="0" />
                                        </ElFormItem>
                                    </ElCol>
                                    <ElCol :sm="12" :md="12">
                                        <ElFormItem label="Nr de lugares VIP" prop="vips">
                                            <ElInputNumber name="vips" v-model="event.vips" :step="1" :min="0" />
                                        </ElFormItem>
                                    </ElCol>
                                </ElRow>
                                <ElDivider />
                                <ElRow>
                                    <ElCol :sm="12" :md="12" class="text-warning">
                                        <strong>{{ event.remaining_places }}</strong> <label> Lugares restantes</label>
                                    </ElCol>
                                    <ElCol :sm="12" :md="12" class="text-success">
                                        <strong>{{ event.remaining_vips }}</strong> <label> Lugares VIP restantes</label>
                                    </ElCol>
                                </ElRow>
                                <ElDivider />

                                <el-form-item label="Cadastrado">
                                    Por&emsp;<b>{{ event.user?.name }}</b>, em&emsp;<b> {{ event.created_at ? new Date(event.created_at).toLocaleString():'-' }}</b>
                                </el-form-item>
                            </el-col>
                            <el-col :sm="24" :md="12" :lg="14">
                                <el-form-item label="Local" prop="area.name" v-if="event.area">
                                    <el-input name="area" v-model="event.area.name" />
                                </el-form-item>
                                <div style="height: 400px; width: 100%" class="position-relative">
                                    <el-button plain class="position-absolute end-0" style="z-index: 1024;" :loading="locating || loading" size="large" type="success" @click.prevent="locate">
                                        Localizar-me
                                    </el-button>
                                    <LMap @contextmenu="onMapClick" ref="map" v-if="event.area" :zoom="16" :center="[event.area.lat, event.area.long]">
                                        <LTileLayer
                                            url="http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}&s=Ga"
                                            layer-type="base"
                                            name="OpenStreetMap"
                                        ></LTileLayer>

                                        <LMarker v-if="event.area" :lat-lng="[event.area.lat, event.area.long]">
                                            <LTooltip>{{ event.name }}</LTooltip>
                                        </LMarker>
                                    </LMap>
                                </div>
                                <ElFormItem label="Imagem promocional" prop="image">
                                    <img style="max-height: 250px; max-width: 100%;" :src="(event.image as string)" />
                                    <input type="file" name="image" @change="changeFile" />
                                </ElFormItem>
                            </el-col>
                        </el-row>
                    </el-form>
                    <el-row justify="space-between" class="py-4 no-print">
                        <el-col class="col-auto">
                            <el-button type="warning" @click="openTickets" plain :loading="saving">
                                Bilhetes comprados
                            </el-button>
                            <el-button type="success" @click="print" plain :loading="saving">
                                Imprimir lista
                            </el-button>
                        </el-col>
                        <el-col class="col-auto">
                            <el-button type="primary" @click="submit(formRef)" plain :loading="saving">
                                Salvar alterações
                            </el-button>
                        </el-col>
                    </el-row>
                </template>
            </el-skeleton>

            <div class="no-screen">
                <ElDescriptions
                    class="margin-top"
                    title="Detalhes do eventos"
                    :column="3"
                    :size="'default'"
                    border
                >
                    <ElDescriptionsItem>
                        <template #label>
                            <div class="cell-item">
                                Nome do evento
                            </div>
                        </template>
                        {{ event.name }}
                    </ElDescriptionsItem>
                    <ElDescriptionsItem>
                        <template #label>
                            <div class="cell-item">
                                Local
                            </div>
                        </template>
                        {{ event.area.name }}
                    </ElDescriptionsItem>
                    <ElDescriptionsItem>
                        <template #label>
                            <div class="cell-item">
                                Data e hora
                            </div>
                        </template>
                        {{ new Date(event.event_time).toLocaleString('af') }}
                    </ElDescriptionsItem>
                    <ElDescriptionsItem>
                        <template #label>
                            <div class="cell-item">
                                Pre&ccedil;0 Normal
                            </div>
                        </template>
                        {{ event.price }} MT
                    </ElDescriptionsItem>
                    <ElDescriptionsItem>
                        <template #label>
                            <div class="cell-item">
                                Pre&ccedil;o VIP
                            </div>
                        </template>
                        {{ event.vip_price }}
                    </ElDescriptionsItem>
                </ElDescriptions>
                <h5 class="pt-4">Bilhetes</h5>
                <table class="table" :cellpadding="5">
                    <tr>
                        <th>Cod</th>
                        <th>Nome</th>
                        <th>idade</th>
                        <th>BI</th>
                        <th>VIP?</th>
                    </tr>
                    <tr v-for="ticket in tickets" :key="ticket.id">
                        <td>{{ ticket.id }}</td>
                        <td>{{ ticket.name }}</td>
                        <td>{{ ticket.old }}</td>
                        <td>{{ ticket.id_number }}</td>
                        <td>{{ ticket.vip ? 'VIP':'NORMAL' }}</td>
                    </tr>
                </table>
            </div>
        </el-card>
        <ElDialog align-center center show-close :title="'Lista Bilhetes comprados'" class="no-print" v-model="showTickets">
            <table class="list-tickets">
                <template v-for="ticket in tickets" :key="ticket.id">
                    <tr>
                        <td><ElTag size="small" :type="ticket.vip ? 'success':'info'">{{ ticket.vip ? 'VIP':'Normal' }}</ElTag></td>
                        <td style="width: 60% !important; text-align: left;">| {{ ticket.name }}</td>
                        <td><ElText type="success" style="text-align: right">{{ ticket.price }} MT</ElText> &emsp;</td>
                        <td><ElTag size="small" :type="ticket.used_at ? 'danger':'success'">{{ ticket.used_at ? 'Usado':'Valido' }}</ElTag></td>
                    </tr>
                </template>
            </table>
        </ElDialog>
    </div>
</template>

<script setup lang="ts">
    import Api from '@/services/api';
    import { Event, Ticket } from '@/services/types';
    import { ElTag, ElDialog, ElDatePicker, ElMessage, ElRow, FormInstance, FormRules, ElCol, ElInputNumber, ElInput, ElDivider, ElFormItem, ElDescriptions, ElDescriptionsItem } from 'element-plus';
    import { onBeforeMount, reactive, ref } from 'vue';
    import { useRoute } from 'vue-router';
    import "leaflet/dist/leaflet.css";
    import { LMap, LTileLayer, LMarker, LTooltip} from "@vue-leaflet/vue-leaflet"
    import { LeafletMouseEvent } from 'leaflet'
    import { toFormData } from '@/utilities/helpers';

    const route = useRoute()
    const id = route.params.id

    const loading = ref<boolean>(true)
    const saving = ref<boolean>(false)
    const locating = ref<boolean>(false)
    const showTickets = ref<boolean>(false)
    const formRef = ref<FormInstance>()
    const image = ref<File | null>(null)
    const apiImage = ref<string>()

    const event = reactive<Event>({
        type: '',
        description: '',
        event_time: new Date(),
        image: null,
        name: '',
        places: 0,
        price: 0,
        vip_price: 0,
        vips: 0,
        remaining_places: 0,
        remaining_vips: 0,
        area: {lat: 0, long: 0, name: ''}
    })

    const getImageUrl = (image: string) => `${Api.publicUrl}alt-storage?path=events/${image}`
    const tickets = ref<Array<Ticket>>([])

    const rules = ref<FormRules<Event>>({
        name: [{required: true, message: 'Preencha este campo'}],
        "area.name": [{required: true, message: 'Preencha este campo'}],
    })

    const openTickets = () => {
        showTickets.value = true
    }

    const changeFile = ({target: {files}}: any) => {
        console.log(files)
        if (files[0]) {
            image.value = files[0]
            event.image = URL.createObjectURL(files[0])
        } else {
            image.value = null
            event.image = (apiImage.value as string)
        }
    }

    const print = () => window.print()
    const getEvent = async (id: number | string) => {
        const res = await Api.get(`admin/events/${id}`)

        if (res.status == 200) {
            const data = res.data.event
    
            event.id = data.id
            event.area = data.area
            event.type = data.type
            event.remaining_places = data.remaining_places
            event.remaining_vips = data.remaining_vips
            event.user = data.user
            event.vips = data.vips
            event.vip_price = data.vip_price
            event.type = data.type
            event.price = data.price
            event.places = data.places
            event.name = data.name
            event.description = data.description
            event.event_time = data.event_time
            event.created_at = data.created_at

            apiImage.value = getImageUrl(data.image)
            event.image = apiImage.value
            console.log(data)
        } else {
            ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
        }
    }
    
    const getTickets = async (id: number | string) => {
        const res = await Api.get(`admin/events/tickets/${id}`)
        if (res.status == 200) {
            tickets.value = res.data.tickets
        } else {
            ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
        }
    }

    const onMapClick = (mouseEvent: LeafletMouseEvent) => {
        const { lat, lng } = mouseEvent.latlng
        if (event.area) {
            event.area.lat = lat
            event.area.long = lng
        } else {
            event.area = {
                name: '',
                lat,
                long: lng
            }
        }
        console.log(event.area);
    }

    const locate = async () => {
        locating.value = true

        if (!navigator.geolocation) {
            alert("Geolocalização não é suportada pelo seu navegador.")
            locating.value = false
            return
        }

        navigator.geolocation.getCurrentPosition((position) => {
            if (event.area) {
                event.area.lat = position.coords.latitude
                event.area.long = position.coords.longitude
            }
            locating.value = false
        }, (err) => {
            console.log(err)
            alert("Ocorreu um erro ao tentar localizar")
            locating.value = false
        })
    }

    const submit = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        if (!event.area?.lat || !event.area.long) {
            ElMessage.error({message: 'Por favor selecione o local no mapa'})
            return null
        }
        await formEl.validate(async (valid) => {
            if (valid) {
                saving.value = true
                const formData = toFormData(event)
                if (image.value) {
                    formData.append("image", image.value)
                } else {
                    formData.delete("image")
                }
                const res = await Api.post('/admin/events/' + event.id, event, formData)
                if (res.status == 200) {
                    await getEvent(id as string)
                } else {
                    ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
                }
                saving.value = false
            }
        })
    }

    onBeforeMount(async () => {
        loading.value = true
        await Promise.all([
            getEvent(id as string),
            getTickets(id as string),
        ])
        loading.value = false
    })
</script>

<style lang="scss" scoped>
    table.list-tickets {
        width: 100% !important;
    }
    table.list-tickets td {
        padding-top: 10px;
        padding-bottom: 10px;
    }
    table.list-tickets tr {
        border-bottom: 1px solid gray;
    }
    .table td, .table th, .table {
        border: 1px solid gray;
    }
    @media screen {
        .no-screen {
            display: none !important;
        } 
    }
    @media print {
        .print-sheet {
            position: fixed;
            top: 0;
            left: 0;
            z-index: 1026;
            width: 100vw !important;
            min-height: 100vh !important;
        }
        .no-print {
            display: none !important;
        }
        /* .no-screen {
            display: block;
        } */
    }
</style>